// Pure helpers for UserDialog: validation + async payload builder.
// Keeps the component small and the logic unit-testable.
import { hashPin } from "../../lib/crypto";
import { loadUsers, uid } from "../../lib/storage";
import { ROLES } from "../../constants";

// Returns null when valid, otherwise an error string to toast.
export function validateUserForm(form) {
  if (!form.name.trim()) return "Name is required";
  if (!/^[a-z0-9._-]{2,32}$/.test((form.username || "").trim().toLowerCase())) {
    return "Username must be 2–32 letters, numbers, dots, dashes, or underscores";
  }
  const pinTyped = form.pin || "";
  if (pinTyped && !/^\d{4}$/.test(pinTyped)) return "PIN must be 4 digits";
  if (!form.pinHash && !pinTyped) return "PIN must be 4 digits";
  if (form.role === ROLES.EMPLOYEE && (!form.areas || form.areas.length === 0)) {
    return "Pick at least one area for an employee";
  }
  return null;
}

export async function buildUserPayload(form, existing) {
  const id = existing?.id || uid("u");
  const pinTyped = form.pin || "";
  const pinHash = pinTyped ? await hashPin(pinTyped) : form.pinHash;
  const others = loadUsers().filter((u) => u.id !== id);
  const username = form.username.trim().toLowerCase();
  const usernameClash = others.some((u) => {
    const existingUsername = (u.username || u.email?.split("@")[0] || "").trim().toLowerCase();
    return existingUsername === username;
  });
  if (usernameClash) throw new Error("Username already in use by another user");
  const clash = others.some(
    (u) => (u.pinHash && u.pinHash === pinHash) || (!u.pinHash && u.pin === pinTyped)
  );
  if (clash) throw new Error("PIN already in use by another user");
  // strip plaintext pin from the persisted record
  // eslint-disable-next-line no-unused-vars
  const { pin: _plain, ...rest } = form;
  const isMainUser = form.role === ROLES.MAIN;
  return {
    ...rest,
    id,
    name: form.name.trim(),
    username,
    email: form.email.trim(),
    restaurant: isMainUser ? null : form.restaurant,
    areas: form.role === ROLES.EMPLOYEE ? form.areas : [],
    area: form.role === ROLES.EMPLOYEE ? form.areas?.[0] || null : null, // legacy compat
    pinHash,
  };
}
